import StyleSettingsHeader from './StyleSettingsHeader';
import { StyleSettingsHeaderProps, StyleSettingsHeaderValueProps } from './types';

export type { StyleSettingsHeaderProps, StyleSettingsHeaderValueProps };
export default StyleSettingsHeader;
